import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { isObject } from 'src/helper/utils';
import { approvedUnderReview, getVendorDetails, getVendors } from 'src/redux/vendors/api';
import type { InitialStateType, VendorDataType } from 'src/redux/vendors/types';

const extraReducers = (builder: ActionReducerMapBuilder<InitialStateType>) => {
  builder.addCase(getVendors().pending, (state: InitialStateType) => {
    state.isLoading = true;
  });
  builder.addCase(getVendors().fulfilled, (state: InitialStateType, action) => {
    if (Number(action.meta.arg.page || 0) > 1) {
      // data will be appending to the previous data.
      const usersListData = [
        ...(state?.data?.data || []),
        ...(action?.payload?.data?.map((item: VendorDataType) => item?.vendor_id) || []),
      ];
      if (action?.payload) {
        state.data = {
          data: usersListData,
          meta: action?.payload?.meta || {},
        };
      }
    } else {
      state.data = {
        data: action?.payload?.data?.map((item: VendorDataType) => item?.vendor_id),
        meta: action?.payload?.meta || {},
      };
    }
    const newSource = { ...(state?.source || {}) };
    action?.payload?.data?.forEach((item: VendorDataType) => {
      let newData = { ...(newSource?.[item?.vendor_id] || {}) };

      const itemKeys = Object.keys(item) as Array<keyof typeof item>;

      itemKeys?.forEach((fieldKey) => {
        if (isObject(item?.[fieldKey]) && isObject(newData[fieldKey])) {
          newData = {
            ...newData,
            [fieldKey]: {
              ...((newData?.[fieldKey] || {}) as Record<string, any>),
              ...((item?.[fieldKey] || {}) as Record<string, any>),
            },
          };
        } else {
          newData = {
            ...newData,
            [fieldKey]: item?.[fieldKey],
          };
        }
      });

      newSource[item?.vendor_id] = newData;
    });
    state.isLoading = false;
    state.source = newSource;
  });
  builder.addCase(getVendors().rejected, (state: InitialStateType) => {
    state.isLoading = false;
  });

  // Get vendor details
  builder.addCase(getVendorDetails().pending, (state: InitialStateType) => {
    state.isDetailsLoading = true;
  });

  builder.addCase(getVendorDetails().fulfilled, (state: InitialStateType, action) => {
    state.isDetailsLoading = false;
    state.source = {
      ...(state?.source || {}),
      [action?.payload?.vendor_id]: action?.payload,
    };
  });

  builder.addCase(getVendorDetails().rejected, (state: InitialStateType) => {
    state.isDetailsLoading = false;
  });

  builder.addCase(approvedUnderReview().fulfilled, (state: InitialStateType, action) => {
    const updatedVendor = {
      ...(state?.source?.[action?.payload?.vendor_id] || {}),
      onboarding: {
        vendor_onboarding_id: action?.payload?.onboarding_id || '',
        status: {
          label: action?.payload?.status?.name || '',
          slug: action?.payload?.status?.slug || '',
        },
      },
    };
    state.source = {
      ...(state?.source || {}),
      [action?.payload?.vendor_id]: updatedVendor,
    };
  });
};

export default extraReducers;
